import { ProductClassification } from "interfaces";
import { create } from "zustand";

interface ProdClassificationStoreProps {
  idDelete: number;
  productClassification: ProductClassification | null;
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  setProductClassification: (
    productClassification: ProductClassification | null
  ) => void;
  setIdDelete: (id: number) => void;
}

export const useProdClassificationStore = create<ProdClassificationStoreProps>(
  (set) => ({
    idDelete: 0,
    productClassification: null,
    isEdit: false,
    setIsEdit: (isEdit: boolean) => set({ isEdit }),
    setProductClassification: (
      productClassification: ProductClassification | null
    ) => set({ productClassification }),
    setIdDelete: (id: number) => set({ idDelete: id }),
  })
);
